import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=42dd7355&scoped=true"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dd7355",
  null
  
)

export default component.exports